import "./EntityUpdate.scss";
import React, { useEffect, useState } from "react";
import {
    Col,
    Row,
    Input,
    Select,
    message,
    Button,
    Modal,
    Upload,
    Form
  } from "antd";
import { ArrowRightOutlined, LoadingOutlined } from "@ant-design/icons";
import ENVIRONMENT from "../../../../environments";
import axios from "axios";
import _ from "lodash";
import * as Styles from "../../../../Styles";
import FileConstants from "../../../../FileConstants";
import * as Constants from "../../CustomerComponents/Constants";
import { platform } from "chart.js";

const { Option } = Select;

const MODEL_JOBS = [
    "material_renders",
    "product_base_assets",
    "product_asset_convertor",
    "product_quick_renders",
    "room_base_assets",
    "room_quick_renders",
    "scene_renders"
];

const SpaceActionForm = () => {
    const [form] = Form.useForm();
    const [inputValue, setInputValue] = useState("");
    const [isLoading, setIsLoading] = useState(false);
    const [isDataLoaded, setIsDataLoaded] = useState(false);
    const [spaceData, setSpaceData] = useState({});
    const [hasError, setHasError] = useState(false);
    const [updateVisible, setUpdateVisible] = useState(false);
    const [spaceCategories, setSpaceCategories] = useState([]);
    const [categoryValue, setCategoryValue] = useState("");
    const [prevCategory, setPrevCategory] = useState("");
    const [currentStatus, setCurrentStatus] = useState("");
    const [selectedStatus, setSelectedStatus] = useState("");
    const [spaceReplaceModal, setSpaceReplaceModal] = useState(false);
    const [replaceFile, setReplaceFile] = useState('');
    const [overrideSpaceModel, setOverrideSpaceModel] = useState([]);
    const [uploadError, setUploadError] = useState('');
    const [fileUploadComplete, setFileUploadComplete] = useState(false);
    const [updateLoader, setUpdateLoader] = useState(false);
    const [isClosing, setIsClosing] = useState(false);

    const SPACE_FILE_TYPES = {
        MAX: ".zip",
        GLB: ".glb",
        THUMBNAIL: ".jpg,.jpeg,.png",
        ARTIST_THUMBNAIL: ".jpg,.jpeg,.png"
    };

    useEffect(() => {
        setSpaceCategoriesData();
    }, [])
    const handleInputChange = (e) => {
        setInputValue(e.target.value);
        if (hasError && e.target.value) {
          setHasError(false);
        }
    };
    const changeModelStatus = (value) => {
        setSelectedStatus(value);
    }
    
    const setSpaceCategoriesData = () => {
        let payload = {
          'request_type': 'room_model'
        }
        axios.post(ENVIRONMENT.GET_CATEGORY_AND_PRICE,payload)
        .then(res => {
          let categories = []
          if (res.data) {
            res.data.map((request) => {
              if (!categories.includes(request.category)) {
                categories.push(request.category);
              }
            })
            categories = categories.filter(item => item !== '')
            setSpaceCategories(categories);
          }
        })
      }

    const handleSubmit = () => {
        setUpdateVisible(false);
        console.log("Input Value:", inputValue);
        if (!inputValue) {
          setHasError(true);
          message.error("Space ID cannot be empty.");
          return;
        }
        let payload = {
          room_id: `${inputValue}`,
        };
        setIsLoading(true);
        setIsDataLoaded(false);
        axios
          .post(ENVIRONMENT.FETCH_ROOM, payload)
          .then((res) => {
            console.log(res.data)
            if (!_.isEmpty(res.data)) {
                const data = res.data;
                console.log("*****", data)
                setCategoryValue(data.category)
                setPrevCategory(data.category)
                setCurrentStatus(data.model_status)
                setSelectedStatus(data.model_status)
                setSpaceData(data)
                setIsDataLoaded(true);
                setIsLoading(false)
              
            } else {
              message.error("Error in fetching Space data");
            }
          }).catch(() => {
            message.error("Error in fetching Space data");
            setIsLoading(false);
          })
      };
    
    const ResetData = () => {
        setCategoryValue(spaceData.category);
        setPrevCategory(spaceData.category);
        setCurrentStatus(spaceData.model_status);
        setSelectedStatus(spaceData.model_status);
      };

    useEffect(() => {
        if (categoryValue !== prevCategory || currentStatus !== selectedStatus) {
          setUpdateVisible(true);
        } else {
          setUpdateVisible(false);
        }
      }, [categoryValue, selectedStatus]);

    const statusOptions = ["3", "4", "5"].filter((status) => status !== currentStatus);

    const handleFileChange = info => {
        let fileList = [...info.fileList];
        fileList = fileList.slice(-1);
        setOverrideSpaceModel(fileList);
        form.setFieldsValue({ override_model: fileList.length > 0 ? fileList : undefined });
        if(fileList.length > 0 && fileList[0]['status'] == 'done'){
            setFileUploadComplete(true)
        }
    };

    const handleModalClose = () => {
        setIsClosing(true);
        setTimeout(() => {
            setSpaceReplaceModal(false);
            form.resetFields();
            setOverrideSpaceModel([]);
            setIsClosing(false);
        }, 400);
    };

    const openReplaceModal = (type) => {
        setReplaceFile(type);
        setSpaceReplaceModal(true);
    }

    const onUpdate = (regenerate) => {
        form.validateFields().then((values) => {
            handleUpdate('replace', regenerate);
        }).catch((info) => {
            console.log('Validation Failed:', info);
        });
    };

    const handleUpdate = (action, regenerate_job = false) => {
        setUpdateLoader(true);
        let payload = {
            action: action,
            room_id: inputValue,
            platform: spaceData.platform,
            admin_username: localStorage.getItem('username')
        };

        if (action == 'update'){
            if (categoryValue !== prevCategory) {
                payload.category = categoryValue;
            }
            if (currentStatus !== selectedStatus) {
                payload.model_status = selectedStatus;
            }
        } else if (action == 'replace'){
            if(overrideSpaceModel.length > 0){
                payload.replace_file = overrideSpaceModel;
                payload.file_type = replaceFile;
            }
        }

        if (regenerate_job && MODEL_JOBS.includes(replaceFile)) {
            payload.regenerate_job = true;
        }

        axios
            .post(ENVIRONMENT.ROOM_MODEL_ACTIONS, payload)
            .then((res) => {
                if(action == 'update'){
                    if (regenerate_job) {
                        message.info("Category updated successfully and Job Regenerated");
                    } else {
                        message.info("Category updated successfully");
                    }
                }
                else if(action == 'replace'){
                    if (regenerate_job) {
                        message.info("File Replaced successfully and Job Regenerated");
                    } else {
                        message.info("File Replaced successfully");
                    }
                    setSpaceReplaceModal(false);
                    setOverrideSpaceModel([]);
                } 
                setUpdateLoader(false);
                handleSubmit();
            })
            .catch(() => {
                message.error("Error in updating space");
            });
    };

    return (
        <div>
        <div style={{ padding: "20px" }}>
            <Row gutter={16}>
                <Col span={8}>
                    <div style={{ marginBottom: "16px" }}>
                        <label>ALL3D ID</label>
                        <div className="input-container">
                            <Input
                            placeholder="Please enter All3D Space ID"
                            type="number"
                            value={inputValue}
                            onChange={handleInputChange}
                            className={`custom-input-id ${hasError ? "input-error" : ""}`}
                            onPressEnter={handleSubmit}
                            suffix={
                                <div className="suffix-container" onClick={handleSubmit}>
                                {isLoading ? (
                                    <LoadingOutlined className="custom-icon" />
                                ) : (
                                    <ArrowRightOutlined className="custom-icon" />
                                )}
                                </div>
                            }
                            />
                        </div>
                    </div>
                    {
                        isDataLoaded ? (
                            <>
                            <div style={{ marginBottom: "16px", display: 'flex', flexDirection: 'column' }}>
                                <label>Category</label>
                                <Select
                                showSearch={true}
                                className={`manrope f-14 black-55 custom-tree-select`}
                                placeholder="Search and select your space category"
                                onChange={(value) =>
                                    setCategoryValue(value)
                                  }
                                value={categoryValue}
                                >
                                    {spaceCategories && spaceCategories.map((category,index) => {
                                        return <Option className="manrope f-14 black-55 select-view" value={category}>{category}</Option>

                                    })}
                                </Select>
                            </div>
                            <div style={{ marginBottom: "16px" }}>
                                <label>System State</label>
                                <Select
                                style={{ lineHeight: "220%", paddingLeft: "0px" }}
                                className="manrope f-14 label-data"
                                value={FileConstants.MODEL_STATUS[selectedStatus]}
                                onChange={changeModelStatus}
                                >
                                {statusOptions.map((key) => (
                                    <Select.Option key={key} value={key}>
                                    {FileConstants.MODEL_STATUS[key]}
                                    </Select.Option>
                                ))}
                                </Select>
                            </div>

                            <div style={{ marginBottom: "16px" }}>
                                <label>Max Bundle</label>
                                <div className="manrope f-14 label-data"
                                    style={{ display: "flex", alignItems: "center", overflow: "hidden", }}>
                                    <div style={{ flexBasis: "70%", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
                                        <a target="_blank" rel="noopener noreferrer" href={ENVIRONMENT.getBaseURL(spaceData.platform) + ENVIRONMENT.SPACE_LOW_POLY_URI + inputValue + ".zip"}>
                                            {ENVIRONMENT.getBaseURL(spaceData.platform) + ENVIRONMENT.SPACE_LOW_POLY_URI + inputValue + ".zip"}
                                        </a>
                                    </div>
                                    <div style={{ flexBasis: "30%", display: "flex", justifyContent: "end"}}>
                                        <Button className="modal-okay square font-12" onClick={ () => openReplaceModal("MAX")}>
                                            Replace
                                        </Button>
                                    </div>
                                </div>
                            </div>

                            <div style={{ marginBottom: "16px" }}>
                                <label>GLB</label>
                                <div className="manrope f-14 label-data"
                                    style={{ display: "flex", alignItems: "center", overflow: "hidden", }}>
                                    <div style={{ flexBasis: "70%", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
                                        <a target="_blank" rel="noopener noreferrer" href={ENVIRONMENT.getBaseURL(spaceData.platform) + ENVIRONMENT.ROOM_ASSET_GLB_URI + inputValue + ".glb"}>
                                            {ENVIRONMENT.getBaseURL(spaceData.platform) + ENVIRONMENT.ROOM_ASSET_GLB_URI + inputValue + ".glb"}
                                        </a>
                                    </div>
                                    <div style={{ flexBasis: "30%", display: "flex", justifyContent: "end"}}>
                                        <Button className="modal-okay square font-12" onClick={ () => openReplaceModal("GLB")}>
                                            Replace
                                        </Button>
                                    </div>
                                </div>
                            </div>

                            <div style={{ marginBottom: "16px" }}>
                                <label>Thumbnail Image</label>
                                <div className="manrope f-14 label-data"
                                    style={{ display: "flex", alignItems: "center", overflow: "hidden", }}>
                                    <div style={{ flexBasis: "70%", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
                                        <a target="_blank" rel="noopener noreferrer" href={spaceData.thumbnail ? spaceData.thumbnail.replace(ENVIRONMENT.DEFAULT_BASE_URL, ENVIRONMENT.getBaseURL(spaceData.platform)) : "#"}>
                                            {spaceData.thumbnail ? spaceData.thumbnail.replace(ENVIRONMENT.DEFAULT_BASE_URL, ENVIRONMENT.getBaseURL(spaceData.platform)) : "No thumbnail available"}
                                        </a>
                                    </div>
                                    <div style={{ flexBasis: "30%", display: "flex", justifyContent: "end"}}>
                                        <Button className="modal-okay square font-12" onClick={ () => openReplaceModal("THUMBNAIL")}>
                                            Replace
                                        </Button>
                                    </div>
                                </div>
                            </div>

                            <div style={{ marginBottom: "16px" }}>
                                <label>Artist Image</label>
                                <div className="manrope f-14 label-data"
                                    style={{ display: "flex", alignItems: "center", overflow: "hidden", }}>
                                    <div style={{ flexBasis: "70%", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
                                        <a target="_blank" rel="noopener noreferrer" href={spaceData.test_renders && spaceData.test_renders.length > 0 ? ENVIRONMENT.getBaseURL(spaceData.platform) + 'test_files/space_test_renders/' + spaceData.test_renders[0].uid + '/' + spaceData.test_renders[0].name : "#"}>
                                            {spaceData.test_renders && spaceData.test_renders.length > 0 ? ENVIRONMENT.getBaseURL(spaceData.platform) + 'test_files/space_test_renders/' + spaceData.test_renders[0].uid + '/' + spaceData.test_renders[0].name : "No artist thumbnail available"}
                                        </a>
                                    </div>
                                    <div style={{ flexBasis: "30%", display: "flex", justifyContent: "end"}}>
                                        <Button className="modal-okay square font-12" onClick={ () => openReplaceModal("ARTIST_THUMBNAIL")}>
                                            Replace
                                        </Button>
                                    </div>
                                </div>
                            </div>
                            </>
                        ) : ''
                    }
                </Col>
                {isDataLoaded ? (
                    <Col span={8} offset={4}>
                        <div style={{ marginBottom: "16px" }}>
                            <label>Space Name</label>
                            <div className="manrope f-14 label-data">
                            <span>{spaceData['room_name']}</span>
                            </div>
                        </div>
                        <div
                        style={{
                            height: "100%",
                            maxHeight: "405px",
                            maxWidth: "405px",
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            border: "0.1px solid",
                            marginBottom: "16px",
                        }}
                        >
                        <img
                            src={
                            spaceData.thumbnail
                                ? spaceData.thumbnail.replace(
                                    ENVIRONMENT.DEFAULT_BASE_URL,
                                    ENVIRONMENT.getBaseURL(spaceData.platform)
                                )
                                : require("../../../../assets/images/product_incomplete.svg")
                            }
                            style={{
                            width: "100%",
                            height: "100%",
                            objectFit: "contain",
                            filter: spaceData.thumbnail ? "none" : "blur(3px)"
                            }}
                        />
                        {!spaceData.thumbnail && (
                            <span
                            style={{
                                position: "absolute",
                                backgroundColor: "rgba(0, 0, 0, 0.6)",
                                color: "white",
                                padding: "6px 12px",
                                borderRadius: "4px",
                                fontWeight: "bold",
                                fontSize: "16px",
                                top: "50%"
                            }}
                            >
                            In Progress
                            </span>
                        )}
                        </div>
    
                    </Col>
                    ) : (
                    ""
                    )}
            </Row>
            </div>
            {updateVisible ? 
                <div className="bottom-menu">
                <div className='mr-20 justify-in-end'> 
                    <div style={{ marginBottom: '16px', display: 'flex', justifyContent: 'space-evenly'}}>
                        <Button className='product-btn br-4 f-16 light-blue pd-16' onClick={ResetData}>
                            Reset
                        </Button>
                        <Button className='product-btn dark-blue f-16 ml-16 br-4 pd-16' onClick={() => handleUpdate('update', false)}>
                            Update
                        </Button>
                        <Button className='product-btn dark-blue f-16 ml-16 br-4 pd-16' onClick={() => handleUpdate('update', true)}>
                            Update and Regenerate
                        </Button>
                    </div>  
                </div>
                </div> : ''}

            <Modal bodyStyle={{ paddingTop: "2px", paddingBottom: "0px" }}
                className={`modal-share-success ${isClosing ? 'fade-out' : 'fade-up-center'}`}
                title={`Space ${replaceFile === "THUMBNAIL" ? "Thumbnail Image" : replaceFile === "ARTIST_THUMBNAIL" ? "Artist Image" : replaceFile} File Replace`}
                visible={spaceReplaceModal}
                width={500}
                centered={true}
                closable={false}
                transitionName={null}
                maskStyle={{
                    backdropFilter: 'blur(10px)', 
                    backgroundColor: 'rgba(0, 0, 0, 0.5)',
                }}
                footer={[
                    <span className="justify-in-center">
                        <Button
                            style={{ textAlign: "center" }}
                            className="modal-okay-gray square font-12"
                            onClick={handleModalClose}
                        >
                            Cancel
                        </Button>
                        <Button
                            style={{ textAlign: "center" }}
                            className="modal-okay square font-12"
                            onClick={() => onUpdate(false)}
                            disabled={!fileUploadComplete || overrideSpaceModel.length == 0 || uploadError != ""}
                        >
                            {updateLoader ? (
                                <span>
                                    {" "}
                                    Updating... <LoadingOutlined spin />
                                </span>
                            ) : (
                                <span>Update </span>
                            )}
                        </Button>
                        {replaceFile == "MAX" && MODEL_JOBS.includes(replaceFile) && <Button
                            style={{ textAlign: "center" }}
                            className="modal-okay square font-12"
                            onClick={() => onUpdate(true)}
                            disabled={!fileUploadComplete || overrideSpaceModel.length == 0 || uploadError != ""}
                        >
                            {updateLoader ? (
                                <span>
                                    {" "}
                                    Updating... <LoadingOutlined spin />
                                </span>
                            ) : (
                                <span>Update and Regenerate</span>
                            )}
                        </Button>}
                    </span>
                ]}>
                <div>
                    <Form form={form} className="input-form">
                        <Row type="flex">
                            <Col span={24} style={{padding: 12}}>
                                <div className="d-flex" style={{justifyContent:"center"}}>
                                    <div style={{minWidth:"100%"}}>
                                        <Form.Item name={'override_model'} label={replaceFile === "THUMBNAIL" ? "Thumbnail Image" : replaceFile === "ARTIST_THUMBNAIL" ? "Artist Thumbnail Image" : "Space Model"} style={{display: 'flow'}} colon={false}
                                            rules={[{ required: true, message: 'Please upload file to replace' }]}>
                                            <Upload
                                                accept={SPACE_FILE_TYPES[replaceFile]}
                                                {...Constants.getUploadProps(spaceData.platform)}
                                                multiple={true}
                                                listType="text"
                                                fileList={overrideSpaceModel}
                                                onChange={handleFileChange}
                                                className="upload-lg-btn ant-upload-picture-card-wrapper upload-box-color-admin"
                                                beforeUpload={file => {
                                                    if(replaceFile === "THUMBNAIL" || replaceFile === "ARTIST_THUMBNAIL") {
                                                        // For thumbnails, just validate file type
                                                        const validTypes = SPACE_FILE_TYPES[replaceFile].split(',');
                                                        const fileExtension = '.' + file.name.split('.').pop().toLowerCase();
                                                        if(!validTypes.includes(fileExtension)) {
                                                            setUploadError("Invalid file type. Please upload JPG, JPEG, or PNG files.");
                                                            return false;
                                                        }
                                                        setUploadError("");
                                                        return true;
                                                    } else if(file.name != inputValue + `${SPACE_FILE_TYPES[replaceFile]}`){
                                                        setUploadError("Invalid filename, file must be named " + inputValue + `${SPACE_FILE_TYPES[replaceFile]}`)
                                                        return false;
                                                    }
                                                    else{
                                                        setUploadError("")
                                                        return true;
                                                    }
                                                }}
                                                onRemove={file => {
                                                    setOverrideSpaceModel([])
                                                    setUploadError("")
                                                }}
                                            >
                                                <div className="d-flex">
                                                    <img className="" src={require("../../../../assets/images/upload.png")} alt=""></img>
                                                    <div className="ant-upload-text">
                                                        <div className="up-info">Drop your Files</div>
                                                        <div>Support: {replaceFile === "THUMBNAIL" || replaceFile === "ARTIST_THUMBNAIL" ? "JPG, JPEG, PNG" : SPACE_FILE_TYPES[replaceFile]}</div>
                                                    </div>
                                                </div>
                                            </Upload>
                                            {uploadError == "" ? "" :
                                                <div style={{marginBottom: 8}}>
                                                    <span className="category-artist red">{uploadError}</span>
                                                </div>
                                            }
                                        </Form.Item>
                                    </div>
                                </div>
                            </Col>
                        </Row>
                    </Form>
                </div>
            </Modal>
        </div>
    )
}

export default SpaceActionForm;